export * from './EventStream';
//# sourceMappingURL=index.js.map